import Base from './Base'

export default class Step extends Base {
    type = 'step';
        
    toJSON = () => {
        let me = this, _this = {};
        ['_id', 'ref_id', 'parent', 'type', 'position', 'name', 'price', 'originalPrice', 'image', 'description', 'items', 'new', 'delete', 'show', 'highlight'].map((prop) => { _this[prop] = me[prop]; });
        return _this;
    }
}